enum MediaFormats {
  Logo = 'logo',
  RectLogo = 'rectLogo',
  GameWallpaper = 'gameWallpaper',
  Wallpaper = 'wallpaper',
  PortraitWallpaper = 'portraitWallpaper',
  Question = 'question',
  CTA = 'CTA',
  Interstitial = 'interstitial',
  SocialShare = 'socialShare',
  Background = 'background',
  HomeScreen = 'homeScreen',
  GridImage = 'gridImage',
  ImagePin = 'imagePin',
};

export default MediaFormats;
